import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import {
  InputCommentsUpdateResponseType,
  InputDataDetailsKey,
  SampleCommentValidFormDataType,
} from '../schema/types';
import { InputDataUrl } from './InputDataUrl';
import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import {
  getMutationFn,
  HttpHeaders,
} from '../../common/queryClient/getMutationFn';
import { InputCommentsUpdateResponseSchema } from '../schema/InputDataDetailsSchema';
import { SampleCommentMutationDtoSchema } from '../schema/SampleCommentSchema';

export interface InputDataDetailsCommentsUpdate {
  params: InputDataDetailsKey;
  comments: SampleCommentValidFormDataType[];
}

const putInputDataDetailsComments = (
  _id: number,
  params: Partial<InputDataDetailsCommentsUpdate>,
  headers?: HttpHeaders,
): Promise<InputCommentsUpdateResponseType> =>
  apiClient
    .put<InputCommentsUpdateResponseType>(
      expand(InputDataUrl.INPUT_DATA_DETAILS_COMMENTS, params.params),
      {
        comments: params.comments?.map((comment) =>
          SampleCommentMutationDtoSchema.parse(comment),
        ),
      },
      headers ? { headers } : undefined,
    )
    .then((response) => InputCommentsUpdateResponseSchema.parse(response.data));

export const useInputDataDetailsCommentsMutation = createApiMutationHook(
  ['inputDataDetailsCommentsMutation'],
  getMutationFn(undefined, putInputDataDetailsComments),
);
